import _ from 'vue-upload-component';
import * as changeCase from 'change-case';

export function mqttWildcard(topic, wildcard) {
  if (topic === wildcard) {
    return [];
  } else if (wildcard === '#') {
    return [topic];
  }

  const res = [];

  const t = String(topic).split('/');
  const w = String(wildcard).split('/');

  let i = 0;
  for (var lt = t.length; i < lt; i++) {
    if (w[i] === '+') {
      res.push(t[i]);
    } else if (w[i] === '#') {
      res.push(t.slice(i).join('/'));
      return res;
    } else if (w[i] !== t[i]) {
      return null;
    }
  }

  if (w[i] === '#') {
    i += 1;
  }

  return i === w.length ? res : null;
}
export function isBinary(str) {
  const matched = str.match('~[^\x20-\x7E\t\r\n]~');
  return !!matched;
}
export function copyToClipboard(text) {
  try {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement('textarea');
      textarea.textContent = text;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
      document.body.appendChild(textarea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      const range = document.createRange();
      range.selectNode(textarea);
      selection.addRange(range);
      document.execCommand('copy'); // Security exception may be thrown by some browsers.
      selection.removeAllRanges();
      document.body.removeChild(textarea);
    }
    return true;
  } catch (ex) {
    return false;
  }
}

export function deleteIdKey(data) {
  const newData = Object.keys(data);
  const newArr = {};
  const newValueData = Object.values(data);
  for (let i = 0; i < newValueData.length; i++) {
    if (!newData[i].includes('_id')) {
      const tempObj = new Object();
      tempObj[newData[i]] = newValueData[i];
      Object.assign(newArr, tempObj);
    }
  }
  return newArr;
}

export function getUrl() {
  const { hostname } = window.location;
  return `${getSchema()}://${hostname}:${window.location.port}`;
}

export function getWsUrl() {
  const { hostname } = window.location;
  const schema = isHttps() ? 'wss': 'ws';
  return `${schema}://${hostname}:${window.location.port}`;
}

export function getSchema() {
  return isHttps() ? 'https': 'http';
}

function isHttps() {
  return window.location.protocol.includes('https:')
}

export function getVariableName(str, variables) {
  if (!variables) {
    variables = [];
  }
  const indexStart = str.indexOf('${');
  let variable = '';
  if (indexStart > -1) {
    const otherStr = str.substring(indexStart + 2, str.length);
    const indexEnd = otherStr.indexOf('}');
    if (indexEnd > 0) {
      variable = str.substring(indexStart + 2, indexStart + indexEnd + 2);
      str = str.substring(indexStart + indexEnd + 3, str.length);
      variables.push(variable);
    } else {
      return variables;
    }
  }
  if (variable !== '' && str.length > 3) {
    getVariableName(str, variables);
  }
  return variables;
}
export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
export function isValidObject(data, require) {
  let result = true;
  if (isJsonString(data)) {
    Object.keys(JSON.parse(data)).forEach(e => {
      if (!require.includes(e)) {
        result = false;
        return result;
      }
    });
  } else {
    result = false;
  }
  return result;
}
export function isValidArray(data, require) {
  let result = true;
  if (isJsonString(data) && Array.isArray(JSON.parse(data))) {
    JSON.parse(data).forEach(e => {
      Object.keys(e).forEach(r => {
        if (!require.includes(r)) {
          result = false;
          return result;
        }
      });
    });
  } else {
    result = false;
  }
  return result;
}
export function exportJSON(fileName, dataExport) {
  const blob = new Blob([dataExport], { type: 'text/plain' });
  const e = document.createEvent('MouseEvents'),
    a = document.createElement('a');
  a.download = `${fileName}.json`;
  a.href = window.URL.createObjectURL(blob);
  // a.dataset.downloadurl = ['devices/csv', a.download, a.href].join(':');
  e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  a.dispatchEvent(e);
}

export function exportOpenVPNConfig(fileName, dataExport) {
  const blob = new Blob([dataExport], { type: 'text/plain' });
  const e = document.createEvent('MouseEvents'),
    a = document.createElement('a');
  a.download = `${fileName}.ovpn`;
  a.href = window.URL.createObjectURL(blob);
  // a.dataset.downloadurl = ['devices/csv', a.download, a.href].join(':');
  e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  a.dispatchEvent(e);
}

export function exportENV(fileName, data) {
  const type = 'data:text/plain;charset=utf-8';
  const link = document.createElement('a');
  var file = new Blob([data], { type: type });
  link.href = URL.createObjectURL(file);
  link.setAttribute('download', `${fileName}.env`);
  link.click();
}

export function exportCSV(fileName, dataExport, config = { simple: false }) {
  function convertToCSVContent(data) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    let header = {};
    data.forEach((item, index) => {
      for (const key in item) {
        header = { ...header, key };
        if (!header[key]) {
          header[key] = Array(data.length).fill('');
        }
        if (item[key]) {
          header[key][index] = item[key];
        }
      }
    });
    delete header.key;
    csvContent += Object.keys(header).join(',') + '\n';
    const totalKeys = Object.keys(header).length;
    data.forEach((item, index) => {
      let count = 0;
      for (const key in header) {
        count++;
        const sysbol = count === totalKeys ? '' : ',';
        csvContent += header[key][index] + sysbol;
      }
      csvContent += '\n';
    });
    return csvContent;
  }

  const csv = convertToCSVContent(dataExport);
  const data = encodeURI(csv);
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', `${fileName}.csv`);
  link.click();
}

export function exportExcel(fileName, dataExport, type) {
  function convertToExcelContent(data) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    let header = {};
    data.forEach((item, index) => {
      for (const key in item) {
        header = { ...header, key };
        if (!header[key]) {
          header[key] = Array(data.length).fill('');
        }
        if (item[key]) {
          header[key][index] = item[key];
        }
      }
    });
    delete header.key;
    csvContent += Object.keys(header).join(' \t') + '\n';
    const totalKeys = Object.keys(header).length;
    data.forEach((item, index) => {
      let count = 0;
      for (const key in header) {
        count++;
        const sysbol = count === totalKeys ? '' : '\t';
        csvContent += header[key][index] + sysbol;
      }
      csvContent += '\n';
    });
    return csvContent;
  }

  const csv = convertToExcelContent(dataExport);
  const data = encodeURI(csv);
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', `${fileName}.xlsx`);
  link.click();
}

export function toUpperTextKey(str) {
  if (str) {
    return str
      .toLowerCase()
      .split('_')
      .map(function(word) {
        return word[0].toUpperCase() + word.substr(1);
      })
      .join(' ');
  }
}

export function convertPointsValueToString(points, deleteFields) {
  const result = JSON.parse(JSON.stringify(points)).map(point => {
    if (deleteFields && deleteFields.length > 0) {
      deleteFields.forEach(fieldName => {
        delete point[fieldName];
      });
    }
    Object.keys(point).map(key => {
      if (typeof point[key] === 'object' && point[key] !== null) {
        delete point[key];
      }
      if (typeof point[key] == 'boolean' || (point[key] && typeof point[key] != 'string')) {
        point[key] = JSON.stringify(point[key]);
      }
    });
    return point;
  });
  return result;
}

export function conventionNaming(stringName, { caseType, enableChangeCase }) {
  return enableChangeCase ? changeCase[caseType](stringName) : stringName;
}
